import DPDropDown from 'framework/components/DPDropDown';
import DPSwitch from 'framework/components/DPSwitch';
import DPTextBox from 'framework/components/DPTextBox';
import { Text, Numeric } from 'framework/validators/TextValidation';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';


export const DynamicUIFromSPContent = ({
    handleChange,
    parameters,
    formValues,
    spDropdownList,
    selectedDropdown,
    setSelectedDropdownOnChange,
    keepSelectedSP,
    setKeepSelectedSP
}) => {
    return (
        <>
            <Row>
                <Col md={6}>
                    <DPDropDown
                        optionGroup={spDropdownList}
                        selectedGroup={selectedDropdown}
                        onChange={setSelectedDropdownOnChange}
                        labelText={"Select Stored Procedure"}
                    />
                </Col>
                <Col sm={2}>
                    <Label
                        htmlFor="example-text-input"
                        className={`col-md-12 col-form-label-sm`}
                    >
                        Keep Selected SP
                    </Label>
                </Col>
                <Col>
                    <DPSwitch
                        rowClass={"mb-4-sm"}
                        onChange={setKeepSelectedSP}
                        checked={keepSelectedSP}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>



                    {parameters.map(param => {

                        if (param.mode == 'IN') {

                            let dataType = '';

                            switch (param.dataType) {
                                case 'numeric':
                                    dataType = 'number';
                                    break;
                                case 'int':
                                    dataType = 'number';
                                    break;
                                case 'decimal':
                                    dataType = 'number';
                                    break;
                                case 'date':
                                    dataType = 'date';
                                    break;
                                case 'datetime':
                                    dataType = 'date';
                                    break;
                                case 'time':
                                    dataType = 'time';
                                    break;
                                case 'bit':
                                    dataType = 'checkbox';
                                default:
                                    dataType = 'text';
                                    break;
                            }


                            const isSwitch = param.dataType == 'bit' ? true : false;

                            return (
                                <div key={param.name}>
                                    {!isSwitch ? <DPTextBox
                                        labelText={param.name.toString().replace('@', '')}
                                        value={formValues[param.name]}
                                        onChange={(e) => {

                                            let currentValue = e.target.value;

                                            if (param.dataType == 'numeric' || param.dataType == 'decimal' || param.dataType == 'int') {

                                                let decimalPalces = param.dataType == 'decimal' || param.dataType == 'numeric' ? 2 : 0;

                                                currentValue = Numeric(e.target, 18, decimalPalces, false)

                                            } else if (param.dataType == 'date' || param.dataType == 'datetime' || param.dataType == 'time') {
                                                currentValue = e.target.value
                                            } else {
                                                currentValue = Text(e.target, param.maxLength, true, true, 'any', true)
                                            }

                                            handleChange(param.name, e.target.value)

                                        }}
                                        maxLength={param.maxLength || ''}
                                        name={param.name}
                                        textType={dataType || 'text'}
                                    /> :
                                        <Row>
                                            <Col sm={3}>
                                                <Label
                                                    htmlFor="example-text-input"
                                                    className={`col-md-12 col-form-label-sm`}
                                                >
                                                    {param.name.toString().replace('@', '')}
                                                </Label>
                                            </Col>
                                            <Col>
                                                <DPSwitch
                                                    rowClass={"mb-4-sm"}
                                                    onChange={(e) => handleChange(param.name, e)}
                                                    checked={formValues[param.name]}
                                                    Title={param.name.toString().replace('@', '')}
                                                />
                                            </Col>
                                        </Row>


                                    }
                                </div>
                            )
                        }
                    }
                    )}
                </Col>
            </Row>
        </>

    )
}

